import React, { Component } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
import { withTranslation } from 'react-i18next';
class ModalDelete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
    };
    this.closeAddModal = this.closeAddModal.bind(this);
  }
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }

  closeAddModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onClose();
    }, 400);
  };

  render() {
    const { event, t } = this.props;
    return (
      <StyleRoot>
        <div
          class="modal fade show modal-skin"
          id="modalDelete"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <button
                type="button"
                onClick={this.closeAddModal}
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close className="img-fluid" alt="" />
              </button>
              <div class="modal-body">
                <section>
                  {event && event.statutEvent !== "ANNULE" ? (
                    <h5 class="modal-title">{t('events.what_to_do')}</h5>
                  ) : (
                    <h5 class="modal-title">{t('events.delete_event')}</h5>
                  )}
                </section>
                <section>
                  {event && event.statutEvent !== "ANNULE" ? (
                    <h5>
                      {t('events.delete_explanation')}
                      <br />
                      {t('events.cancel_explanation')}
                    </h5>
                  ) : (
                    <h5>{t('events.confirm_delete')}</h5>
                  )}
                </section>
                <p class="bottom-space"></p>
                <div class="d-flex justify-content-center">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.handleDeleteEvent(e);
                    }}
                    class="btn-gradient btn-delete"
                    data-dismiss="modal"
                  >
                    {t('common.delete')}
                  </button>
                  {event && event.statutEvent !== "ANNULE" ? (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.handleCancelEvent(e);
                      }}
                      class="btn-gradient btn-white"
                      data-dismiss="modal"
                    >
                      {t('events.cancel_event')}
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}

export default withTranslation()(ModalDelete);
